import { gql } from "@apollo/client";
import { fragments as hddOrderStatusFragments } from "../../application/apps/HDDPressApp/components/HDDOrderStatus/graph";

const markOrderAsHighDefinitionDigitalStartedMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsHighDefinitionDigitalStarted(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...HDDOrderStatus_order
      }
      succeeded
    }
  }
  ${hddOrderStatusFragments.order}
`;

export default markOrderAsHighDefinitionDigitalStartedMutation;
